import styled from "styled-components";

export const Styles = styled.div`
  * {
    @media print {
      &::-webkit-scrollbar {
        display: none !important;
      }

      scrollbar-width: none !important;

      -ms-overflow-style: none !important;

      @page {
        padding: 20px !important;
      }

      /* Hide buttons and action panels */
      button,
      .ant-btn,
      .button,
      .button-collapse,
      .action-buttons-container,
      .action_cell {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
        opacity: 0 !important;
      }

      /* Hide table headers */
      .table-div__header,
      .table-div__header-cell {
        display: none !important;
        height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
      }

      /* Hide horizontal/vertical lines and borders in tables */
      .table-div,
      .table-div__body,
      .table-div__row,
      .table-div__cell,
      .is-table,
      .layout-grid-item.is-table {
        border: none !important;
        border-width: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        outline: none !important;
      }

      /* Hide pulldown arrows/suffix icons in selectors */
      .ant-select-arrow,
      .ant-select-suffix,
      .ant-select-arrow-icon,
      .select-arrow,
      .suffix-icon,
      svg[class*="arrow"],
      svg[class*="down"],
      svg[class*="pulldown"],
      .icon-pulldown {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }

      /* Hide upload drag zone + paste input, keep file list */
      .ant-upload.ant-upload-drag {
        display: none !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
      }

      .table-div__header {
        align-items: flex-start !important;
      }

      .table-div__body .table-div__row {
        align-items: flex-start !important;
      }

      .table-div__body .table-div__row:not(:first-child) .table-div__cell {
        align-items: flex-start !important;
      }

      .table-div__body .table-div__row:first-child .table-div__cell {
        align-items: flex-start !important;
      }

      .table-div__header,
      .ffGnkp .table-div__row {
        grid-template-columns: 0.75fr 1.25fr 2fr 1fr;
      }
    }
  }

  /* Screen/PDF global table styling overrides */
  @media print {
    .table-div,
    .table-div__body {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
      border: none !important;
    }

    .table-div__row {
      display: grid !important;
      width: 100% !important;
      border: none !important;
    }

    .table-div__cell {
      border: none !important;
      padding: 4px 8px !important;
    }
  }
`;
